/* Preserve the theme's category click/navigation behavior; sync local semantics. */
(() => {
  if (customElements.get('olitans-category-navigation')) return;

  class CategoryNavigation extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.media = window.matchMedia('(max-width: 1024px)');
      this.heading = this.querySelector('button.sidebarBlock-heading');
      this.panel = this.querySelector('.sidebarBlock-content');
      this.back = this.querySelector('.sidebarBlock-slide__content-close');
      this.sync = this.syncState.bind(this);
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const branch = event.target.closest('.navPages-item.is-clicked, .navPage-subMenu-item.is-clicked');
        const toggle = branch?.querySelector(':scope > button.icon-dropdown');
        if (toggle) {
          event.preventDefault();
          event.stopPropagation();
          toggle.click();
          toggle.focus();
        } else if (this.dataset.mode === 'slide' && this.panel?.classList.contains('is-show')) {
          event.preventDefault();
          event.stopPropagation();
          this.back?.click();
          this.heading?.focus();
        }
      };
      this.addEventListener('keydown', this.onKeydown);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      if (this.media.addEventListener) this.media.addEventListener('change', this.sync);
      else this.media.addListener(this.sync);
      this.syncState();
    }

    syncState() {
      if (this.heading && this.panel) {
        const isSlide = this.dataset.mode === 'slide';
        const expanded = isSlide
          ? (!this.media.matches || this.panel.classList.contains('is-show'))
          : this.heading.classList.contains('is-clicked');
        const wasExpanded = this.heading.getAttribute('aria-expanded') === 'true';
        const focusWasInside = this.contains(document.activeElement);
        this.heading.setAttribute('aria-expanded', String(expanded));
        this.panel.setAttribute('aria-hidden', String(!expanded));
        this.panel.toggleAttribute('inert', !expanded);
        this.heading.parentElement.toggleAttribute('inert', isSlide && this.media.matches && expanded);
        if (isSlide && this.media.matches && expanded !== wasExpanded) {
          const focusTarget = expanded ? this.back : this.heading;
          if (focusWasInside) focusTarget?.focus({ preventScroll: true });
        }
      }

      this.querySelectorAll('button.icon-dropdown').forEach((button) => {
        const expanded = button.parentElement.classList.contains('is-clicked');
        const panel = button.parentElement.querySelector(':scope > .dropdown-category-list');
        button.setAttribute('aria-expanded', String(expanded));
        panel?.setAttribute('aria-hidden', String(!expanded));
        panel?.toggleAttribute('inert', !expanded);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.removeEventListener('keydown', this.onKeydown);
      if (this.media?.removeEventListener) this.media.removeEventListener('change', this.sync);
      else this.media?.removeListener(this.sync);
    }
  }

  customElements.define('olitans-category-navigation', CategoryNavigation);
})();
